export const searchableSelectCheck = (value, valueSpec) => {
  if (!value) {
    return false;
  }
  if (!valueSpec || !valueSpec.enums) {
    return false;
  }
  // If value is an object, use its value property
  const actualValue = typeof value === "object" ? value.value : value;

  // Check if the value exists in enums, handling both string and object cases
  const exists = valueSpec.enums.some(
    (enumValue) =>
      (typeof enumValue === "object" ? enumValue.value : enumValue) ===
      actualValue
  );
  if (!exists) {
    return false;
  }
  return true;
};
